// @ts-nocheck
import React from "react";
import PCurveGraph from "../PerformanceCurve/PCurveGraph";
import { useDispatch } from "react-redux";
import {
  modalViewsConst,
  setModalOpen,
  setModalState
} from "../../store/modalSlice";
import { ReactComponent as PowerIcon } from "../../assets/icons/lightning.svg";
import ModalHeader from "./ModalHeader";

interface PCurveDisplayProps {
  graphProperties: {
    id: string;
    name: string;
    description: string;
    curveData: Array<{x: number, y: number}>;
    xUnit: string;
    yUnit: string;
    [key: string]: any;
  };
  onClose?: (result?: any) => void;
}

const PCurveDisplay: React.FC<PCurveDisplayProps> = ({ 
  graphProperties,
  onClose
}) => {
  console.log("curveData", graphProperties);
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    if (onClose) {
      onClose();
    } else {
      dispatch(setModalOpen(false));
    }
  };

  const handleEdit = () => {
    // First close this modal
    if (onClose) {
      onClose();
    } else {
      dispatch(setModalOpen(false));
    }
    
    // Then open the edit modal after a small delay to ensure proper transition
    console.log("graphProperties.modalType ", graphProperties.modalType )
    setTimeout(() => {
      dispatch(
        setModalState({
          modalOpen: true,
          // If modalType is present in properties, use windCurveCallback with type callback 
          modalView: graphProperties.modalType === 'callback' ? 
            modalViewsConst.windCurveCallback : 
            modalViewsConst.editPerformanceCurve,
          properties: {
            ...graphProperties,
            // When editing from the preview in callback mode, preserve that
            modalType: graphProperties.modalType === 'callback' ? 'callback' : undefined
          }
        })
      );
    }, 100);
  };
  return (
    <div>
      <ModalHeader
        title={graphProperties.name}
        icon={<PowerIcon stroke="#A2BBBF" className="h-6 w-6" />}
        onClose={handleCloseModal}
        className="p-5"
      />
      <div className="flex flex-col">
        <div className="w-full min-h-64  p-4">
          <PCurveGraph
            data={graphProperties.curveData}
            xAxisLabel={graphProperties.xUnit}
            yAxisLabel={graphProperties.yUnit}
          />
        </div>
        <div className="w-full  px-5 pb-4">{graphProperties.description}</div>
      </div>
      <div className="flex flex-row grow space-x-3 p-5">
        <button 
          className="flex-grow eai-btn my-1" 
          type="button"
          onClick={handleCloseModal}
        >
          <div className="mx-3">Close</div>
        </button>
        <button
          onClick={handleEdit}
          className="flex-grow eai-btn-grn my-1"
          type="button"
        >
          <div className="mx-3">Edit</div>
        </button>
      </div>
    </div>
  );
};

export default PCurveDisplay;
